import { Layout } from "../../components/common/Layout";
import { MedicWorkload } from "../../components/analytics/MedicWorkload";

export const MedicWorkloadPage = () => {
    const title = "Нагрузка на мед. работников";
    
    return (
        <Layout title={title}>
            <MedicWorkload />
        </Layout>
    )
}

